import type { AxiosInstance } from 'axios';
import type { components, paths } from '../schema';
import type { RequestOptions } from './types';
import { curry1 } from './utils';

export type PublicBusinessConfig =
  paths['/api/public/business/config-options']['get']['responses']['200']['content']['application/json'];

export type Business = components['schemas']['BusinessSerializerV2'];

export const getPublicBusinessConfig = async (
  instance: AxiosInstance,
  options?: RequestOptions
): Promise<PublicBusinessConfig> => {
  const res = await instance.get<PublicBusinessConfig>(
    '/public/business/config-options',
    options
  );

  return res.data;
};

export class BusinessService {
  public getPublicBusinessConfig;

  constructor(private instance: AxiosInstance) {
    this.getPublicBusinessConfig = curry1(getPublicBusinessConfig)(
      this.instance
    );
  }
}
